<template>
  <div class="bg-[#23242A] text-white custom p-3" id="content_screen">
    <div :class="'p-3 flex content-main ' ">
      <div class="custom-full custom-left">
        <Nav/>
        <div class="bg-[#2B2C32] rounded-lg px-[16px]">
          <template v-if="vg_selectedLocation.id">
            <div class="flex flex-col justify-between pb-5">
              <h2 class="text-[24px] py-4 font-semibold text-white">Compliance Report</h2>
              <div class="w-[500px] grid grid-cols-2 gap-4">
                <div class="flex flex-col">
                    <span class="text-sm mb-1">Report Year</span>
                    <select v-model="year" class="bg-[#464851] border-none rounded focus:outline-none focus:border-none">
                      <option value="" selected disabled>
                        -- Select --
                      </option>
                      <option v-bind:key="year + 'year'" v-for="year in years" :value="year">{{ year }}</option>
                    </select>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm mb-1">Report Month</span>
                    <select v-model="month" class="bg-[#464851] border-none rounded">
                      <option value="" selected disabled>
                        -- Select --
                      </option>
                      <option v-for="(month, ind) in months" :key="ind" :value="ind+1">{{ month }}</option>
                    </select>
                </div>
              </div>
              <button v-if="providerName!=='mbll'" @click="generateReport" :disabled="!month || !year" :class="(!!month && !!year)?'bg-theme-green text-white':''" class="w-[500px] mt-6 uppercase tracking-[0.1px] font-medium h-[40px] rounded bg-[#414141] text-[#9E9E9E] px-4 py-2">GENERATE Compliance Report</button>
              <div v-else class="w-[500px] grid grid-cols-2 gap-4">
                  <button @click="generateReport('CTLS')" :disabled="!month || !year" :class="(!!month && !!year)?'bg-theme-green text-white':''" class=" mt-6 uppercase tracking-[0.1px] font-medium h-[40px] rounded bg-[#414141] text-[#9E9E9E] px-4 py-2">GENERATE CTLS Report</button>
                  <button @click="generateReport('LGCA')" :disabled="!month || !year" :class="(!!month && !!year)?'bg-theme-green text-white':''" class=" mt-6 uppercase tracking-[0.1px] font-medium h-[40px] rounded bg-[#414141] text-[#9E9E9E] px-4 py-2">GENERATE LGCA Report</button>
              </div>
            </div>

          </template>
        </div>
      </div>
      
    </div>
  </div>
</template>


<script lang="ts">
import { useRoute, useRouter } from 'vue-router'
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import Nav from '@/views/Inventory/Audits/Report/Nav.vue';
import Helpers from '@/helpers'
import moment from 'moment'
import BusinessProductApi from '@/controllers/BusinessProductApis'
import LocationComplianceApis from '@/controllers/LocationComplianceApis';
import { useSnackbar } from "vue3-snackbar"

  export default defineComponent({
  name: "ComplianceReport",
  components: {
    Nav,
  },

  setup() {
    const router = useRouter()
    const route = useRoute()
    const snackbar = useSnackbar();
    const action = ref<object>({
      component: '',
      data: {},
    });
    const year = ref('')
    const month = ref('')
    const providerName = ref('ocs');
    const monthName = ref(['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'])
    return {
      router,
      route,
      snackbar,
      action,
      year,
      month,
      providerName,
      monthName
    };
  },

  mounted(){
    this.getComplianceProvider()
  },
  watch: {
    vg_selectedLocation(){
      if(this.vg_selectedBusiness?.id){
        this.getComplianceProvider()
      }
    }
  },

  computed: {
    years () {
      const year = new Date().getFullYear()
      // check if month is valid
      // if(this.month && !this.isFuture(this.month)){
        
      // }else if(this.year){
      //   this.month = ''
      // }
      return Array.from({length: year - 2015}, (value, index) => 2016 + index)
    },
    months () {
      const month = moment.months();
      return month
    },
    can_edit_audit() {
        return Helpers.getMyPermission('can_edit_audit')
    },
    ...mapGetters({
     vg_selectedLocation: 'location/selected',
     vg_selectedBusiness: 'auth/activeBusiness',
    }),
  },


  beforeDestroy() {
    this.emitter.off('reset-product-categories-component', () => {});
    this.emitter.off('refresh-product-categories-list', () => {});
  },
  
 
  methods: {
    async getComplianceProvider(){
      let res = await LocationComplianceApis.fetch();
      if(res?.data?.payload?.providerName){
        this.providerName = res?.data?.payload?.providerName
      }else{
        this.providerName = 'ocs'
      }
    },

    isFuture(month){
      if(moment().format('YYYY')==this.year && moment().format('M')<=month)
        return true
      else
        return false
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.router.push({name: 'ComplianceReport', params: {id: item.id}})
    },

    async generateReport(type=''){
      this.vm_spinner(true)
      let data = {}
      if(this.providerName==='mbll'){
        data = {
          month: this.month,
          year: this.year,
          reportType: type
        }
      }else{
        data = {
          month: this.month,
          year: this.year,
        }
      }
      let res = await BusinessProductApi.generateReport(this.vg_selectedLocation.id, data)
      this.snackbar.add({
          type: 'info',
          text: this.getMessage(res),
          duration: 3000,
      })
      if(res.status==201 || res.status==200){
        const url = window.URL.createObjectURL(new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}));
        const link = document.createElement('a');
        const filename = res.headers['x-suggested-filename']?res.headers['x-suggested-filename']:`Monthly-Report-${this.monthName[this.month]}-${this.year}.xlsx`
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        document.body.removeChild(link)
        link.click();
      }

      this.vm_spinner(false)
    },
    getMessage(res){
      if(res.status && (res.status==201 || res.status==200)){
        return 'Compliance report is generated.'
      }else if(res.status && res.status==403){
        return 'You do not have the permissions required to perform this action'
      }else if(res.response.status==400){
        return 'Please set your compliance provider in integration settings.'
      }else if(res.response.status==404){
        return "Data not found!"
      }else{
        return Helpers.catchErrorMessage(res.response.data)
      }
    },
    ...mapMutations({
      vm_spinner: 'spinner/mutateSpinner'
    }),
    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>